/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { orderUploadStyles } from "@monsma/Overrides/Components/OrderUpload";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButton = {
    css: css`
        margin-bottom: 15px;
    `,
    variant: "secondary",
    sizeVariant: "small",
};

orderUploadStyles.cancelUploadButton = {
    variant: "secondary",
    css: css`
        &&& {
            ${screen("lt", "sm")} {
                width: 100%;
            }
        }
    `,
};

orderUploadStyles.fileUploader = {
    buttonProps: {
        variant: "primary",
        css: css`
            margin-top: 23px;

            ${screen("lt", "sm")} {
                margin-top: 10px;
                margin-left: 0;
            }

            ${TypographyStyle} {
                line-height: 1;
                margin: 15px auto;
                text-transform: capitalize;
            }
        `,
    },
};

orderUploadStyles.uploadFileButton = {
    variant: "primary",
    css: css`
        &&& {
            ${screen("lt", "sm")} {
                width: 100%;
                margin-top: 10px;
            }
        }
    `,
};

orderUploadStyles.mainWrapper = {
    css: css`
        width: 100%;

        div[class^="UploadWrapper"] {
            ${screen("lt", "sm")} {
                flex-direction: column;
            }
        }
    `,
};

(orderUploadStyles as any).actionsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;

        ${screen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};

orderUploadStyles.includeFirstRowCheckbox = {
    css: css`
        ${getProp("theme.checkbox.defaultProps.css")}
        margin: 15px 0;
    `,
};
